

import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ContratoTransportadoraFormDialogComponent } from '../app/home/contrato_transportadora/contrato-transportadora-form-dialog.component';
import { Observable, Subscription, interval, map, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { addDays, format, parseISO } from 'date-fns';
import { ContratoTerrestreFormDialogComponent } from '../app/home/contrato_terrestre/contrato-terrestre-form-dialog.component';
import { ExtraRequestComponent } from '../app/home/extra-request/extra-request.component';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { AppModule } from '../app.module';
import { Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'; // Importe a biblioteca file-saver
import * as ExcelJS from 'exceljs';
import { readFile } from 'xlsx';


@Component({
    selector: 'app-extra-freight-concluded',
    templateUrl: './extra-freight-concluded.component.html',
    styleUrls: ['./extra-freight-concluded.component.css'],
    standalone: false
})
export class ExtraFreightConcludedComponent {

  item: any = {};
  items: any[] = [];
  usuarios: any[] = [];
  carriers: any[] = [];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlNotify: string = 'https://29o5gcw81i.execute-api.sa-east-1.amazonaws.com/v1';
  // urlConsultaCompactada: string = 'https://q9hhz5wjah.execute-api.sa-east-1.amazonaws.com/volumeGD';
  urlConsultaCompactada: string = 'https://ymm2qay9pj.execute-api.sa-east-1.amazonaws.com/V1';
  query: string = 'extraFreight';
  queryUsers: string = 'usersPortal';
  queryCarriers: string = 'Carriers';
  querylocation: string = 'Fornecedores_Karrara_Transport';
  comentario: string = "";
  $even: any;
  $odd: any;
  dataSource: any;
  itemsCarrier: any[] = [];
  itemsCompletos: any[] = [];
  searchString: string = '';
  itemsOrigin: any[] | undefined;
  placesOrigin: any[] | undefined;
  usuarioLogado!: UsuarioLogado;
  currentDate = new Date();
  formattedDate = format(this.currentDate, 'ddMMyyyyHHmmss');
  existingExcelFile: string = 'C:/Users/ssbuif/Desktop/Transport Instruction-teste.xlsx';
  locais!: any[]

  typesVehicles: string[] = [
    'Picape(fiorino) Aberta 500Kg - C1,60 x L1,00 x A1,20',
    'Picape(fiorino) Fechada - C1,60 x L1,00 x A1,20',
    'Picape(fiorino) Refrigerada - C1,60 x L1,00 x A1,20',
    'Kombi 800kg - C1,60 x L1,00 x A1,20',
    'VAN Furgão 1,5t - C3,20 x L1,80 x A1,80',
    'HR Bongo 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Sider 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Aberto 1,5t - C2,80 x L1,80 x A1,80',
    'HR Bongo Refrigerado 1,5t - C2,80 x L1,80 x A1,80',
    'VUC - 3/4 3t - C4,80 x L2,20 x A2,20',
    'VUC - 3/4 Aberto 3t - C4,80 x L2,20 x A2,20',
    'VUC - 3/4 Sider 3t - C4,80 x L2,20 x A2,20',
    'VUC - 3/4 Refrigerado 3t - C4,80 x L2,20 x A2,20',
    'Toco Aberto 6ton - C6,50 x L2,40 x A2,60',
    'Toco Sider 6ton - C6,50 x L2,40 x A2,60',
    'Toco 6ton Refrigerado - C6,50 x L2,40 x A2,60',
    'Truck Aberto 12ton - C8,50 x L2,40 x A2,70',
    'Truck Sider 12ton - C8,50 x L2,40 x A2,70',
    //'Truck Refrigerado 12ton - C8,50 x L2,40 x A2,70',
    'Carreta 25ton Aberta - C14,80 x L2,50 x A2,70',
    'Carreta 25ton Sider - C14,80 x L2,50 x A2,70',
    //'Carreta 25ton Baú - C14,80 x L2,50 x A2,70',
    'Carreta 27ton Aberta - C14,80 x L2,50 x A2,70',
    'Carreta 27ton Sider - C14,80 x L2,50 x A2,70',
    //'Carreta 27ton Baú - C14,80 x L2,50 x A2,70',
    'Truck Munk',
    'Guincho Prancha'
  ];
  dialogOpen!: boolean;
  formBuilder: any;
  formGroup: any;
  selectedValue = 0;
  contactCarrier: string = '';
  contactTrasport: string = '+5511974882943';
  status: string = 'Requested';
  dataNotify: any;
  isCarrierEnabled: boolean = false;
  campoTocado: boolean = false;
  fileName = 'ExcelSheet.xlsx';
  isLoading: boolean = true;
  isUserEnabled: boolean = false;
  isAdminEnabled: boolean = false;
  locationDeliveryChanged!: boolean;
  locationPickupChanged!: boolean;
  subscription: Subscription | undefined;
  referenceDate: any;
  @ViewChild('dateInput2') dateInput2: any;
  dateFilter: any;



  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private autenticacaoService: AutenticacaoService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogado()
    await this.getUsers()
    await this.getCarriers()
    await this.enableFields();
    await this.upDate()
    this.isLoading = false;

    this.subscription = interval(3 * 60 * 1000).subscribe(async () => {
      await this.upDate()
      await this.enableFields();


      this.isLoading = false;

      // }, 1500);
    });

  }

  async upDate() {
    await this.getItemsFromDynamoDB();
    await this.getItemsFromOrigin();
    this.isLoading = false;
    // this.dialogOpen = false;

  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  enableFields() {
    if (this.usuarioLogado.role == '2' || this.usuarioLogado.role == '9') {
      this.isAdminEnabled = true;
    } else if (this.usuarioLogado.role == '1' || this.usuarioLogado.role == '6' || this.usuarioLogado.role == '5' || this.usuarioLogado.role == '7' || this.usuarioLogado.role == '8') {
    // } else if (this.usuarioLogado.role == '1') {
      this.isUserEnabled = true;
    } else if (this.usuarioLogado.role == '3') {
      this.isCarrierEnabled = true;
    }
  }

  editDialog(item: any): void {
// console.log(item)

    this.campoTocado = false;
    this.enableFields();
    //editDialog2(item: any): void {
    this.item = {...item}
    this.item.ID = item.ID ? item.ID : this.formattedDate
    // this.item.motive = item.motive;
    // this.item.nf = item.nf;
    // this.item.plate = item.plate;
    // this.item.totalCost = item.totalCost;
    // this.item.otherLocationDelivery = item.otherLocationDelivery;
    // this.item.otherLocationPickup = item.otherLocationPickup;
    // this.item.nfTotal = item.nfTotal;
    // this.item.weight = item.weight;
    // this.item.quantity = item.quantity;
    // this.item.carrier = item.carrier;
    // this.item.reqVehicle = item.reqVehicle;
    // this.item.vehicleType = item.vehicleType;
    // this.item.description = item.description;
    this.item.reqName = item.reqName ? item.reqName : this.usuarioLogado.nome;
    this.item.reqId = item.reqId ? item.reqId : this.usuarioLogado.id;
    // this.item.region = item.region;
    // this.item.reqEmail = item.reqEmail;
    // this.item.reqPhone = item.reqPhone;
    // this.item.supEmail = item.supEmail;
    // this.item.costCenter = item.costCenter;
    // this.item.projectNumber = item.projectNumber;
    // this.item.orderNumber = item.orderNumber;
    // this.item.locationPickup = item.locationPickup;
    // this.item.areaPickup = item.areaPickup;
    // this.item.addressPickup = item.addressPickup;
    // this.item.cityPickup = item.cityPickup;
    // this.item.statePickup = item.statePickup;
    // this.item.cepPickup = item.cepPickup;
    // this.item.datePickup = item.datePickup;
    // this.item.timePickup = item.timePickup;
    // this.item.locationDelivery = item.locationDelivery;
    // this.item.areaDelivery = item.areaDelivery;
    // this.item.dateDelivery = item.dateDelivery;
    // this.item.addressDelivery = item.addressDelivery;
    // this.item.cityDelivery = item.cityDelivery;
    // this.item.stateDelivery = item.stateDelivery;
    // this.item.cepDelivery = item.cepDelivery;
    // this.item.timeDelivery = item.timeDelivery;
    // this.item.notes = item.notes;
    // this.item.critical = item.critical;
    // this.item.dangerousProduct = item.dangerousProduct;
    // this.item.status = item.status;
// console.log(this.item)
    this.dialogOpen = true;

  }

  onFieldChanged(fieldName: string, newValue: string) {

    // O código a ser executado quando o campo for alterado
    if (fieldName == 'locationDelivery') {
      if (newValue == 'other') {
        this.item.addressDelivery = null
        this.item.cityDelivery = null
        this.item.stateDelivery = null
      } else {
        this.item.addressDelivery = this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco ? this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco : this.item.addressPickup
      }
    } else if (fieldName == 'locationPickup') {
      if (newValue == 'other') {
        this.item.addressPickup = null
        this.item.cityPickup = null
        this.item.statePickup = null
      } else {
        this.item.addressPickup = this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco ? this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco : this.item.addressPickup
      }
    }
    //console.log(`Campo '${fieldName}' alterado para '${newValue}'`);
  }

  solicitarFrete() {
    this.item = {};
    this.item.reqName = this.usuarioLogado.nome;
    this.item.reqId = this.usuarioLogado.id;
    this.item.status = 'New request';
    this.dialogOpen = true;
  }

  async salvar(item: any) {
    // //console.log(this.item.addressDelivery ? this.item.addressDelivery : this.locais.find(end => end.local == this.item.locationDelivery).endereco)
    // //console.log(this.locais.find(end => end.local == this.item.locationDelivery).endereco)
    // this.item.addressDelivery ? this.item.addressDelivery : this.locais.find(end => end.local == this.item.locationDelivery).endereco 
    this.isLoading = true;

    // if (this.locationDeliveryChanged) {
    //   this.item.addressDelivery = ""
    //   this.item.cityDelivery = ""
    //   this.item.stateDelivery = ""
    // }

    // if (this.locationPickupChanged) {
    //   this.item.addressPickup = ""
    //   this.item.cityPickup = ""
    //   this.item.statePickup = ""
    // }
    try {

      if (
        this.item.reqEmail &&
        this.item.reqId &&
        this.item.reqName &&
        this.item.reqPhone &&
        this.item.costCenter &&
        this.item.locationPickup &&
        this.item.datePickup &&
        this.item.timePickup &&
        this.item.locationDelivery &&
        this.item.dateDelivery &&
        this.item.timeDelivery
      ) {
        this.item = {...item}
        //   "ID": this.item.ID ? this.item.ID : this.formattedDate,
        //   "date": this.item.date,
        //   "motive": this.item.motive,
        //   "nf": this.item.nf,
        //   "nfTotal": this.item.nfTotal,
        //   "weight": this.item.weight,
        //   "quantity": this.item.quantity,
        //   "carrier": this.item.carrier,
        //   "reqVehicle": this.item.reqVehicle,
        //   "vehicleType": this.item.vehicleType,
        //   "plate": this.item.plate,
        //   "totalCost": this.item.totalCost,
        //   "description": this.item.description,
        //   "reqName": this.item.reqName,
        //   "reqId": this.item.reqId,
        //   "region": this.item.region,
        //   "reqEmail": this.item.reqEmail,
        //   "reqPhone": this.item.reqPhone,
        //   "supEmail": this.item.supEmail,
        //   "costCenter": this.item.costCenter,
        //   "projectNumber": this.item.projectNumber,
        //   "orderNumber": this.item.orderNumber,
        //   "locationPickup": this.item.locationPickup,
        //   "areaPickup": this.item.areaPickup,
        //   "addressPickup": this.item.addressPickup,// ? this.item.addressPickup : this.itemsOrigin?.find(end => end.local == this.item.locationPickup).endereco,
        //   "cityPickup": this.item.cityPickup,
        //   "statePickup": this.item.statePickup,
        //   "cepPickup": this.item.cepPickup,
        //   "datePickup": this.item.datePickup,
        //   "timePickup": this.item.timePickup,
        //   "locationDelivery": this.item.locationDelivery,
        //   "otherLocationPickup": this.item.otherLocationPickup,
        //   "otherLocationDelivery": this.item.otherLocationDelivery,
        //   "areaDelivery": this.item.areaDelivery,
        //   "dateDelivery": this.item.dateDelivery,
        //   "addressDelivery": this.item.addressDelivery, //? this.item.addressDelivery : this.itemsOrigin?.find(end => end.local == this.item.locationDelivery).endereco,
        //   "cityDelivery": this.item.cityDelivery,
        //   "stateDelivery": this.item.stateDelivery,
        //   "cepDelivery": this.item.cepDelivery,
        //   "timeDelivery": this.item.timeDelivery,
        //   "notes": this.item.notes,
        //   "critical": this.item.critical,
        //   "dangerousProduct": this.item.dangerousProduct,
        //   "status": this.item.status == 'New request' || !this.item.status ? 'Requested' : this.item.status,
        // }
        this.item.tableName = this.query
        // Remover as barras invertidas escapadas
        const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
        const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
        // Converter a string JSON para um objeto JavaScript
        const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
        // Converter o objeto JavaScript de volta para uma string JSON
        const modifiedJsonString = JSON.stringify(jsonObject);
        // //console.log(modifiedJsonString);
        // Converter a string JSON para um objeto JavaScript
        const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
        // Criar um array contendo o objeto
        const jsonArray = [jsonObject2];
        console.log(jsonArray)
        await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
          await this.upDate();
          // this.cdr.detectChanges();
          this.dialogOpen = false;
          this.isLoading = false;
        }, error => {

          console.log(error);
        });

        setTimeout(() => {

        }, 200);
        if (this.item.status == 'Requested') {
          this.dataNotify = {
            "phone_number": this.contactTrasport,
            "message": "Novo frete extra solicitado " + "ID: " + this.item.ID
          };
        } else {
          this.dataNotify = {
            "phone_number": this.contactTrasport,
            "message": "Frete extra " + "ID: " + this.item.ID + " atualizado."
          };
        }
        await this.notify(this.dataNotify);
      } else {
        this.campoTocado = true;
        alert("Formulario incompleto!")
      }
      if (this.item.carrier) {
        await this.notifyCarrier();
      }
      // await this.upDate();
    } catch (error) {
      const confirmacao = window.confirm("Por favor, revise o preenchimento do formulario!");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = false;
        console.error('Error :', error);
      }
    }
  }

  async notifyCarrier() {
    // this.contactCarrier = this.carriers.find(car => car.name == this.item.carrier).contact
    this.dataNotify = {
      //testando antes de enviar para os carriers
      // "phone_number": this.contactCarrier,
      "phone_number": this.contactTrasport,
      "message": "Novo frete extra solicitado " + "ID: " + this.item.ID
    };
    await this.notify(this.dataNotify);
  }


  async notify(data: any) {
    // //console.log("entrou notify")
    const body =
    {
      "Records": [
        {
          "eventName": "INSERT",
          "dynamodb": {
            "NewImage": {
              "phone_number": {
                "S": data.phone_number
              },
              "message": {
                "S": data.message
              }
            }
          }
        }
      ]
    }
    await this.dynamodbService.enviaNotificacao(body, this.urlNotify).subscribe({
      next: response => {
        // //console.log("success")
        // //console.log(response)
      }, error: error => {
        //console.log("error")
        console.log(error);
      }
    });
  }

  async getCarriers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryCarriers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.carriers')
          // //console.log((this.carriers))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getUsers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.usuarios = items.map(item => ({ ...item, checked: false }));
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.usuarios')
          // //console.log((this.usuarios))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  cancel(): void {
    this.campoTocado = false;
    this.dialogOpen = false;
    this.locationDeliveryChanged = false;
    this.locationPickupChanged = false;
  }

  // aplicarFiltro() {
  //   this.items = this.itemsCompletos;
  //   //console.log('entrou no filtro')
  //   //console.log(this.items)
  //   //console.log(this.itemsCompletos)
  //   // Filtrar os itens com base no valor do filtro "Carrier"
  //   this.items = this.items.filter(item => item.locationDelivery?.toLowerCase().includes(this.filtroDelivery?.toLowerCase()));
  // }
  async applyFilter() {
    this.isLoading = true;
    // console.log(this.dateFilter);
    this.dateFilter = this.formatDate(this.dateFilter);
    await this.upDate();
  }

  formatDate(dateString: string): string {
    // Usando parseISO para criar uma data a partir de uma string ISO
    const parsedDate = parseISO(dateString);
    // Usando format para formatar a data para o formato "dd/MM/yyyy HH:mm"
    const futureDate = addDays(parsedDate, 32);  
    // Usando format para formatar a data para o formato "dd/MM/yyyy HH:mm"
    return format(futureDate, "dd/MM/yyyy HH:mm");
  }

  aplicarFiltro() {
    this.items = this.itemsCompletos;
    this.items = this.items.filter(item => this.filtrarItem(item));
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }

    const lowerCaseFilter = this.searchString.toLowerCase();

    // Verificar se alguma propriedade do item corresponde ao filtro (ignorando maiúsculas e minúsculas)
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }

    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log(this.usuarioLogado)
  }


  getStatusClass(status: string): string {
    if (status == 'Planned') {
      this.status = 'planned';
      return 'planned';
    } else if (status == 'Executing') {
      return 'executing';
    } else if (status == 'Completed') {
      return 'completed';
    } else if (status == 'Canceled') {
      return 'canceled';
    } else if (status == 'Rejected') {
      return 'rejected';
    } else {
      return '';
    }
  }

  async openDialog(item: Array<any>, url: string, table: string): Promise<void> {
    const dialogRef: MatDialogRef<ExtraRequestComponent> = this.dialog.open(ExtraRequestComponent, {
      data: {
        itemsData: [],
        url: url,
        query: table
      },
      height: '730px',
      minWidth: '750px',
      position: {
        top: '10vh',
        left: '30vw'
      },
    });
    await dialogRef.afterClosed().subscribe(async () => {
      // if (result) {
      // setTimeout(() => {
      await this.getItemsFromDynamoDB();
      // }, 800); // Ajuste o tempo de atraso conforme necessário
    }
      // //console.log('The dialog was closed');
      // }
    );
  }

  async getItemsFromOrigin(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.querylocation, this.urlConsulta, filtro)).subscribe(
      async (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.itemsOrigin = items.map(item => ({ ...item, checked: false }));

              // Ordena os itens em ordem alfabética com base na propriedade 'local'
              await this.itemsOrigin.sort((a, b) => a.local.localeCompare(b.local));

              // Salva os locais ordenados em this.placesOrigin
              this.placesOrigin = this.itemsOrigin.map(item => item.local);
              this.locais = items;
              // //console.log(this.placesOrigin)
              // //console.log(items)                          
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  convertTimestampToFormattedDate(timestamp: number): string {
    // Converta para segundos dividindo por 1000
    const timestampSeconds = timestamp / 1000;
    // Crie um objeto Date
    const date = new Date(timestampSeconds * 1000); // Multiplique por 1000 para obter milissegundos
    // Formate a data no formato desejado
    const formattedDate = date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // Use formato de 24 horas
    }).replace(',', ''); // Remova a vírgula
    return formattedDate;
  }

  async clearFilter() {
    this.isLoading = true;
    // console.log("clean")
    this.dateInput2.nativeElement.value = '';
    this.dateFilter = null;
    this.referenceDate = new Date();
    // console.log("datefilter")
    // console.log(this.dateFilter)
    await this.upDate();
  }

  async getItemsFromDynamoDB(): Promise<void> {
    // this.items = [];
    let qtdDias = 0;
    if (this.dateFilter) {
      // console.log("datefilter")
      // console.log(this.dateFilter)
      this.referenceDate = this.dateFilter;
      qtdDias = 32;
      // console.log(this.referenceDate)
    } else {
      // console.log("hoje")
      this.referenceDate = this.convertTimestampToFormattedDate(Date.now());
      qtdDias = 180;
      // console.log(this.referenceDate)
    }
    try {
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItemsVolumesAltos(this.query, this.urlConsultaCompactada, 'All', 'date', this.referenceDate, qtdDias)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });
      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          // const filtro = '';
          // (await this.dynamodbService.getItems(this.query, this.urlConsulta, filtro)).subscribe(
          //   (response: any) => {
          //     // //console.log(response)
          //     if (response.statusCode === 200) {
          //       try {
          //         const items = JSON.parse(response.body);
          // console.log(items)
          if (Array.isArray(items)) {
            this.items = items;
            // this.items = items.map(item => ({ ...item, checked: false }));
            if (this.usuarioLogado.role.toString() == '1') {
              //console.log("entrou role 1")
              //console.log(this.usuarioLogado)
              //console.log(this.items.forEach(id => //console.log(id.reqId)))
              this.items = items.filter(item => item.reqId.toLowerCase() == this.usuarioLogado.id.toLowerCase())
            }
            else if (this.usuarioLogado.role != '9' && this.usuarioLogado.role != '2') {
              this.items = items.filter(item => item.carrier == this.usuarioLogado.company)
            }
            this.items = this.items.filter(item => item.status == 'Canceled' || item.status == 'Completed')
            // this.items.sort((a, b) => {
            //   return b.ID.localeCompare(a.ID);
            // });
            this.items.sort((a, b) => {
              try {
                return b.date.localeCompare(a.date);
              } catch {
                // console.log(a);
                // console.log(b);
              }
            });

            this.itemsCompletos = this.items;
            // //console.log(this.items)
            // //console.log(this.itemsCarrier)
            // Adiciona a chave 'checked' a cada item, com valor inicial como false
            // Forçar detecção de alterações após atualizar os dados
            this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
      // },
      // (error: any) => {
      //   console.error(error);
      // }
    } catch (error) {
      console.error('Error parsing JSON:', error);
    }
    // );
  }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {
    const confirmacao = window.confirm("Tem certeza que deseja excluir esta viagem?");

    // Verifica se o usuário confirmou a ação
    if (confirmacao) {
      this.isLoading = true;

      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
        async response => {
          // setTimeout(() => {
          await this.getItemsFromDynamoDB();
          this.isLoading = false;

          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

  //EXPORTAR UMA TABELA
  // exportexcel(): void {
  //   /* pass here the table id */
  //   let element = document.getElementById('excel-table');
  //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

  //   /* generate workbook and add the worksheet */
  //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  //   /* save to file */
  //   XLSX.writeFile(wb, this.fileName);
  // }  

  async exportToExcel(data: any[]): Promise<void> {
    if (data.length === 0) {
      //console.log('Nenhum dado para exportar.');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Obtenha os nomes de todas as colunas a partir do primeiro objeto
    const columnNames = Object.keys(data[0]);

    // Adicione o cabeçalho à planilha e aplique formatação
    const headerRow = worksheet.addRow(columnNames);
    headerRow.font = { bold: true };
    headerRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF0000FF' } // Azul
    };

    // Adicione bordas ao cabeçalho
    headerRow.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };

    // Adicione os dados às linhas da planilha
    data.forEach(item => {
      const row = columnNames.map(column => item[column]);
      const dataRow = worksheet.addRow(row);
      // Adicione bordas aos dados
      dataRow.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Salve o arquivo modificado
    const outputFilePath = 'viagens_frete_extra.xlsx';
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo modificado');
  }




  // exportToExcel(data:any): void {
  //   // Converta o objeto em um array
  //   const dataArray = [data];    
  //   const existingFilePath = 'assets/TransportInstruction.xlsx';
  //   // Carregue o arquivo Excel existente
  //   const existingWorkbook: XLSX.WorkBook = XLSX.read(existingFilePath, { type: 'array' });
  //   // Obtenha a planilha do arquivo existente
  //   const existingWorksheet: XLSX.WorkSheet = existingWorkbook.Sheets['Sheet1'];
  //   //console.log("dados")

  //   for (const item of dataArray) {
  //     //console.log(item)
  //     for (const key in item) {
  //       // //console.log(key)
  //       // //console.log(item[key])
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: 'SCANIA' }], { skipHeader: true, origin: { r: 0, c: 0 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.ID }], { skipHeader: true, origin: { r: 1, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.nfTotal }], { skipHeader: true, origin: { r: 6, c: 12 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.locationPickup }], { skipHeader: true, origin: { r: 8, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.description }], { skipHeader: true, origin: { r: 15, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.addressPickup }], { skipHeader: true, origin: { r: 17, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.cityPickup }], { skipHeader: true, origin: { r: 19, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.statePickup }], { skipHeader: true, origin: { r: 19, c: 2 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.datePickup }], { skipHeader: true, origin: { r: 19, c: 3 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.timePickup }], { skipHeader: true, origin: { r: 19, c: 4 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.notes }], { skipHeader: true, origin: { r: 21, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.locationDelivery }], { skipHeader: true, origin: { r: 24, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.addressDelivery }], { skipHeader: true, origin: { r: 26, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.cityDelivery }], { skipHeader: true, origin: { r: 28, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.stateDelivery }], { skipHeader: true, origin: { r: 28, c: 2 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.dateDelivery }], { skipHeader: true, origin: { r: 28, c: 3 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.timeDelivery }], { skipHeader: true, origin: { r: 28, c: 4 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.vehicleType }], { skipHeader: true, origin: { r: 32, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.reqName }], { skipHeader: true, origin: { r: 35, c: 1 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.reqPhone }], { skipHeader: true, origin: { r: 35, c: 2 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.costCenter }], { skipHeader: true, origin: { r: 35, c: 3 } });
  //       XLSX.utils.sheet_add_json(existingWorksheet, [{ [key]: item.projectNumber }], { skipHeader: true, origin: { r: 37, c: 3 } }); 
  //     }
  //   }   
  //   // Salve uma cópia do arquivo com as novas informações
  //   const newWorkbook: XLSX.WorkBook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(newWorkbook, existingWorksheet, 'Data');

  //   const excelBlob = new Blob([XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' })], {
  //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  //   });

  //   const url = window.URL.createObjectURL(excelBlob);
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.download = 'copied_data.xlsx'; // Nome da cópia
  //   link.click();
  //   window.URL.revokeObjectURL(url); 
  // }  

  // async addImageToExcel(): Promise<void> {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');

  //   const imageSrc = 'assets/SCANIA.png';
  //   const response = await fetch(imageSrc);
  //   const buffer2 = await response.arrayBuffer();
  //   let logo = workbook.addImage({
  //     buffer: buffer2,
  //     extension: 'jpeg',
  //   });
  //   worksheet.addImage(logo, 'B5:C9');
  //   // Salve o arquivo modificado
  //   const outputFilePath = 'modified_data.xlsx';
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //   fs.saveAs(blobData, outputFilePath);

  //   // Exiba um alerta para o usuário baixar o arquivo
  //   alert('Clique para baixar o arquivo modificado');
  // }



  async addImageToExcel(item: any): Promise<void> {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    const imageSrc = 'assets/SCANIA.png';
    const response = await fetch(imageSrc);
    const buffer2 = await response.arrayBuffer();
    let logo = workbook.addImage({
      buffer: buffer2,
      extension: 'jpeg',
    });
    worksheet.addImage(logo, 'B2:C4');

    const imageSrc2 = 'assets/Griffo.png';
    const response2 = await fetch(imageSrc2);
    const buffer3 = await response2.arrayBuffer();
    let logo2 = workbook.addImage({
      buffer: buffer3,
      extension: 'jpeg',
    });
    worksheet.addImage(logo2, 'K2:L4');

    // Defina um objeto com as posições das células e os valores correspondentes
    const cellData = [
      { position: 'B3:N3', value: 'ID: ' + item.ID, isRightAligned: true },
      { position: 'B4:N4', value: 'INSTRUÇÃO DE TRANSPORTE', isBold: true, isCentered: true, backgroundColor: 'FFFACD', border: true },
      { position: 'B6:L6', value: 'LCB - Rua dos Feltrins, 843 - B. Demarchi - SBC - SP', isBold: true, isCentered: true },
      { position: 'B7:L7', value: 'LPC - Rua Comendador João Lucas Vinhedo, 580 - Vinhedo - SP', isBold: true, isCentered: true },
      { position: 'B8:L8', value: 'SLA - Av. José Odorizzi, 151 - São Bernardo - SP', isBold: true, isCentered: true },
      { position: 'M5:N5', value: 'Nº da N.Fiscal' },
      { position: 'M6:N7', value: item.nf, isCentered: true, isBold: true },
      { position: 'M8:N8', value: 'Valor da N.Fiscal' },
      { position: 'M9:N12', value: item.nfTotal, isCentered: true, isBold: true },
      { position: 'B11:C12', value: 'IMPORTANTE:', isBold: true, color: 'FF0000', isCentered: true },
      { position: 'D11:L11', value: '- Para entrega é obrigatório o preenchimento do número e valor da N. Fiscal', color: 'FF0000', isBold: true },
      { position: 'D12:L12', value: '- O endereço constante da NF deve ser o mesmo do destino da mercadoria', color: 'FF0000', isBold: true },
      { position: 'B13:N13', value: 'DADOS PARA LOCALIZAÇÃO DA RETIRADA', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
      { position: 'B14:I14', value: 'Fornecedor / Cliente:' },
      { position: 'B15:I15', value: item.locationPickup == "other" ? item.otherLocationPickup : item.locationPickup + (item.areaPickup ? " - " + item.areaPickup : ""), isBold: true },
      { position: 'J14:L14', value: 'Nome para contato:' },
      { position: 'J15:L15', value: '', isBold: true },
      { position: 'M14:N14', value: 'Tel. contato:' },
      { position: 'M15:N15', value: '', isBold: true },
      { position: 'B16:I16', value: 'Descrição do Material:' },
      { position: 'B17:I17', value: item.description, isBold: true },
      { position: 'J16:L16', value: 'Peso Bruto:' },
      { position: 'J17:L17', value: item.weight, isBold: true },
      { position: 'M16:N16', value: 'Quantidade:' },
      { position: 'M17:N17', value: item.quantity, isBold: true },
      { position: 'B18:N18', value: 'Endereço: ' },
      { position: 'B19:N19', value: item.addressPickup, isBold: true },//(this.locais.find(end => end.local == this.item.locationPickup).endereco ? this.locais.find(end => end.local == this.item.locationPickup).endereco : " falta cadastro ") , isBold: true }, //item.addressPickup, isBold: true },
      { position: 'B20:D20', value: 'Cidade: ' },
      { position: 'B21:D21', value: item.cityPickup, isBold: true },
      { position: 'E20:H20', value: 'Estado: ' },
      { position: 'E21:H21', value: item.statePickup, isBold: true },
      { position: 'I20:L20', value: 'Data da retirada: ' },
      { position: 'I21:L21', value: item.datePickup, isBold: true },
      { position: 'M20:N20', value: 'Horário: ' },
      { position: 'M21:N21', value: item.timePickup, isBold: true },
      { position: 'B22:N22', value: 'Motivo: ' },
      { position: 'B23:N24', value: item.motive, isCentered: true, isBold: true },
      { position: 'B25:N25', value: 'DADOS PARA LOCALIZAÇÃO DA ENTREGA', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
      { position: 'B26:I26', value: 'Fornecedor / Cliente: ' },
      { position: 'B27:I27', value: item.locationDelivery == "other" ? item.otherLocationDelivery : item.locationDelivery + (item.areaPickup ? " - " + item.areaPickup : ""), isBold: true },
      { position: 'J26:L26', value: 'Nome para contato:' },
      { position: 'J27:L27', value: '', isBold: true },
      { position: 'M26:N26', value: 'Tel. contato:' },
      { position: 'M27:N27', value: '', isBold: true },
      { position: 'B28:N28', value: 'Endereço: ' },
      { position: 'B29:N29', value: item.addressDelivery, isBold: true }, // (this.locais.find(end => end.local == this.item.locationDelivery).endereco ? this.locais.find(end => end.local == this.item.locationDelivery).endereco : ""), isBold: true }, //item.addressDelivery, isBold: true },
      { position: 'B30:D30', value: 'Cidade: ' },
      { position: 'B31:D31', value: item.cityDelivery, isBold: true },
      { position: 'E30:H30', value: 'Estado: ' },
      { position: 'E31:H31', value: item.stateDelivery, isBold: true },
      { position: 'I30:J30', value: 'Data da retirada: ' },
      { position: 'I31:J31', value: item.dateDelivery, isBold: true },
      { position: 'K30:N30', value: 'Horário: ' },
      { position: 'K31:N31', value: item.timeDelivery, isBold: true },
      { position: 'B32:N32', value: 'Observações: ' },
      { position: 'B33:N34', value: item.notes, isCentered: true, isBold: true },
      { position: 'B35:N35', value: 'TIPO DE VEÍCULO A SER UTILIZADO', isBold: true, isCentered: true, backgroundColor: 'FFFACD' },
      { position: 'B36:N40', value: item.vehicleType + " - " + item.plate, isCentered: true, isBold: true },
      { position: 'B41:N41', value: 'PREENCHIMENTO OBRIGATÓRIO', isBold: true, isCentered: true, backgroundColor: 'FFFACD', color: 'FF0000' },
      { position: 'B42:E42', value: 'Solicitante: ', color: 'FF0000' },
      { position: 'B43:E43', value: item.reqName, color: 'FF0000', isBold: true },
      { position: 'F42:H42', value: 'Telefone: ', color: 'FF0000' },
      { position: 'F43:H43', value: item.reqPhone, color: 'FF0000', isBold: true },
      { position: 'I42:N42', value: 'Centro de custo: ', color: 'FF0000' },
      { position: 'I43:N43', value: item.costCenter, color: 'FF0000', isBold: true },
      { position: 'B44:C44', value: 'Cod. Sub.: ', color: 'FF0000' },
      { position: 'B45:C45', value: ' ', color: 'FF0000', isBold: true },
      { position: 'D44:J44', value: 'Tipo Material: ', color: 'FF0000' },
      { position: 'D45:J45', value: ' ', color: 'FF0000', isBold: true },
      { position: 'K44:N44', value: 'Pedido de compra: ', color: 'FF0000' },
      { position: 'K45:N45', value: item.projectNumber, color: 'FF0000', isBold: true },
      { position: 'B5:L5', backgroundColor: 'F5FFFA' },
      { position: 'B9:L10', backgroundColor: 'F5FFFA' },
      { position: 'B0:N2', backgroundColor: 'F5FFFA' },


    ];

    // Percorra o objeto cellData e adicione os valores às células
    for (const data of cellData) {
      const cellRange = data.position;
      const valueToFill = data.value;

      // Decodifique a posição da célula de início do intervalo
      const { c: startCol, r: startRow } = XLSX.utils.decode_cell(cellRange.split(':')[0]);

      // Decodifique a posição da célula final do intervalo
      const { c: endCol, r: endRow } = XLSX.utils.decode_cell(cellRange.split(':')[1]);

      // Mesclar as células no intervalo
      worksheet.mergeCells(startRow + 3, startCol, endRow + 3, endCol);

      // Definir o valor da célula mesclada
      // worksheet.getCell(startRow, startCol).value = valueToFill;

      // Definir o valor da célula mesclada
      const cell = worksheet.getCell(startRow + 3, startCol);
      cell.value = valueToFill;

      // Adicionar bordas às células            
      // Configurar bordas se a propriedade border for true
      if (data.border) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      } else {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
      }

      // Aplicar negrito se a propriedade isBold for true
      if (data.isBold) {
        cell.font = { bold: true };
      }

      // Definir a cor do texto se a propriedade color estiver definida
      if (data.color) {
        cell.font = cell.font || {};
        cell.font.color = { argb: data.color };
      }

      // Centralizar o conteúdo horizontalmente e verticalmente
      if (data.isCentered) {
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
      }

      // Alinhar o conteúdo à direita se a propriedade isRightAligned for true
      if (data.isRightAligned) {
        cell.alignment = { horizontal: 'right' };
      }

      // Definir a cor de fundo se a propriedade backgroundColor estiver definida
      if (data.backgroundColor) {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: data.backgroundColor }
        };
      } else {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'F5FFFA' }
        };
      }
    }
    // Salve o arquivo modificado
    const outputFilePath = 'Instrucao de transporte' + item.ID + '.xlsx';
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blobData, outputFilePath);

    // Exiba um alerta para o usuário baixar o arquivo
    alert('Clique para baixar o arquivo modificado');
  }

}